// Frontend plan configuration matching backend
export interface PlanLimits {
  projects: number;
  architectures: number;
  deployments_per_month: number;
  users_per_organization: number;
  pipeline_minutes_per_month: number;
  api_calls_per_month: number;
  storage_gb: number;
  retention_days: number;
  price_monthly_cents: number;
  price_yearly_cents: number;
  features: {
    terraform_generation: boolean;
    cost_estimation: boolean;
    azure_devops_integration: boolean;
    azure_devops_auto_provision: boolean;
    export_diagrams: boolean;
    custom_templates: boolean;
    api_access: boolean;
    priority_support: boolean;
    sla: boolean;
    audit_logs: boolean;
    sso: boolean;
  };
}

const plans: Record<'free' | 'standard' | 'entreprise', PlanLimits> = {
  free: {
    projects: 1,
    architectures: 5,
    deployments_per_month: 3,
    users_per_organization: 1,
    pipeline_minutes_per_month: 100,
    api_calls_per_month: 1000,
    storage_gb: 1,
    retention_days: 30,
    price_monthly_cents: 0,
    price_yearly_cents: 0,
    features: {
      terraform_generation: true,
      cost_estimation: true,
      azure_devops_integration: false,
      azure_devops_auto_provision: false,
      export_diagrams: true,
      custom_templates: false,
      api_access: false,
      priority_support: false,
      sla: false,
      audit_logs: false,
      sso: false,
    },
  },
  standard: {
    projects: 3,
    architectures: 50,
    deployments_per_month: 30,
    users_per_organization: 5,
    pipeline_minutes_per_month: 1000,
    api_calls_per_month: 10000,
    storage_gb: 10,
    retention_days: 90,
    price_monthly_cents: 3900, // 39€/month
    price_yearly_cents: 37440, // 374.40€/year (20% off = 12 months for price of 9.6)
    features: {
      terraform_generation: true,
      cost_estimation: true,
      azure_devops_integration: true,
      azure_devops_auto_provision: false,
      export_diagrams: true,
      custom_templates: true,
      api_access: true,
      priority_support: false,
      sla: false,
      audit_logs: false,
      sso: false,
    },
  },
  entreprise: {
    projects: -1, // unlimited
    architectures: -1,
    deployments_per_month: -1,
    users_per_organization: -1,
    pipeline_minutes_per_month: -1,
    api_calls_per_month: -1,
    storage_gb: -1,
    retention_days: 365,
    price_monthly_cents: 24900, // 249€/month
    price_yearly_cents: 239040, // 2390.40€/year (20% off)
    features: {
      terraform_generation: true,
      cost_estimation: true,
      azure_devops_integration: true,
      azure_devops_auto_provision: true,
      export_diagrams: true,
      custom_templates: true,
      api_access: true,
      priority_support: true,
      sla: true,
      audit_logs: true,
      sso: true,
    },
  },
};

export function getPlanLimits(plan: string | null | undefined): PlanLimits {
  return plans[plan as 'free' | 'standard' | 'entreprise'] ?? plans['free'];
}

export function getAllPlans(): Record<'free' | 'standard' | 'entreprise', PlanLimits> {
  return plans;
}
